jQuery(function($) {

  var win = $(window);
  var body = $('body');
  var header = $('.header');
  var nav = $('.header__nav');

  $('.header__small__menu--toggle').on('click', function(e) {
    body.toggleClass('menu-active');
    mainNav.removeClass('search-open');
    siteSearch.removeClass('is-open');
    searchToggle.removeClass('is-toggled');
    $('.header__small__logo').toggleClass('active');
    e.preventDefault();
  });

  $('.header__small__back').on('click', function(e) {
    header.removeClass('header--back');
    $('.header__wrap .expanded').removeClass('expanded');
    e.preventDefault();
  });


  openChildMenu = function(e) {
    var back = $('.header__small__back__text');
    var item = $(this).parent();
    var text = item.children('a').text();
    if ($('> .menu', item).length) {
      back.text(text);
      $('.header__wrap .expanded').not(item).removeClass('expanded');
      if (item.hasClass('expanded')) {
        item.removeClass('expanded');
        header.removeClass('header--back');
      } else {
        item.addClass('expanded');
        header.addClass('header--back');
      }
      e.preventDefault();
    }
  }

  $('.header__wrap .menu .menu').each(function() {
    var parent = $(this).parent();
    var arrow = $('<a class="header__nav__toggle" href="#"><span class="svgstore svgstore--dropdown-arrow"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="img/svgstore.svg#dropdown-arrow"></use></svg></span></a>');
    arrow.on('click', openChildMenu);
    parent.prepend(arrow);
  });

  // Mobile Submenu navigation action
  $(document).on('click', function(e) {
    if (window.innerWidth >= 1024) {
      $('.header__wrap .expanded').each(function() {
        var container = $(this);
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.removeClass('expanded');
          header.removeClass('header--back');
        }
      });
    }
  });


  $('.header__wrap .nav__menu-item').click(function() {
    if (window.innerWidth < 1024) {
      $('.nav__menu-item .svgstore--dropdown-arrow').toggleClass('active');
      $('.nav__submenu').toggle();
    }
  });


  // Search bar toggle
  var searchToggle = $('.header__search--toggle');
  var siteSearch = $('.header__search');
  var mainNav = $('.header__menu--main');
  var alertToggle = $('.alert');
  var toggleSearch = function() {
    searchToggle.toggleClass('is-toggled');
    siteSearch.toggleClass('is-open');
    mainNav.toggleClass('search-open');
    alertToggle.toggleClass('search-open');
    $('.header__search input').focus();
  };
  searchToggle.click(function(e) {
    e.preventDefault();
    toggleSearch();
    if ($(body).hasClass('menu-active')) {
      body.toggleClass('menu-active');
      $('.header__small__logo').toggleClass('active');
    }
  });
});




